import React, { useState, useEffect } from 'react';
import { getStaffName } from '../../utils/bridgeStaffDisplay';
import AppSelect from '../common/AppSelect';

/** Read-only staff field — always a dropdown when there is at least one person. */
export default function BridgeStaffReadonly({ label, people }) {
  const names = (people || []).map(getStaffName).filter(Boolean);
  const namesKey = names.join('|');
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    setSelectedIndex(0);
  }, [namesKey]);

  return (
    <div className="form-group bridge-staff-readonly">
      <label>{label}</label>
      {names.length === 0 ? (
        <span className="staff-readonly-single">—</span>
      ) : (
        <AppSelect
          className="staff-readonly-app-select"
          value={selectedIndex}
          onChange={(nextValue) => setSelectedIndex(Number(nextValue))}
          options={names.map((name, i) => ({ value: i, label: name }))}
        />
      )}
    </div>
  );
}
